import { useState } from 'react';
import { Modal, Spin } from 'antd';
import React from 'react';
import { calendlyLink } from '@ninja/consts';

const CalendlyModal = (props) => {
  const [loading, setLoading] = useState(true);

  const handleIframeLoad = () => setLoading(false);

  return (
    <Modal footer={false} className='custom-modal' {...props}>
      <div style={{ height: '80vh', position: 'relative' }}>
        {loading && <Spin size='large' className='flex items-center justify-center' />}
        <iframe
          className='col-span-2 w-full h-full rounded-md border-none'
          src={calendlyLink}
          onLoad={handleIframeLoad}
          allowFullScreen
          style={{ visibility: loading ? 'hidden' : 'visible' }}
        />
      </div>
    </Modal>
  );
};

export default CalendlyModal;
